export default "__VITE_ASSET__c4119578__"